export default __webpack_public_path__ + "static/img/codicon.a609dc0f.ttf";